



































import Vue from "vue";
import { Component } from "nuxt-property-decorator";
import amplitude from "amplitude-js";
import ShowcaseNavbar from "~/components/showcase/ShowcaseNavbar.vue";
import BaseLoader from "~/components/core/BaseLoader.vue";
import ShowcaseRendererContainer from "~/components/showcase/ShowcaseRendererContainer.vue";
import FeedbackButton from "~/components/layout/FeedbackButton.vue";
import CookieConsent from "~/components/layout/CookieConsent.vue";
import FeedbackModal from "~/components/modals/FeedbackModal.vue";
import { paymentModuleActive } from "~/config";

@Component({
  name: "ShowcasePage",
  layout: "showcase",
  middleware: ["refreshToken", "locale", "publicProjectId"],
  components: {
    ShowcaseRendererContainer,
    ShowcaseNavbar,
    BaseLoader,
    CookieConsent,
    FeedbackButton,
    FeedbackModal,
    PaymentBlockerModal: () =>
      paymentModuleActive
        ? import("~/components/modals/PaymentBlockerModal.vue")
        : undefined,
    PaymentSuccessModal: () =>
      paymentModuleActive
        ? import("~/components/modals/PaymentSuccessModal.vue")
        : undefined,
    PaymentCancelModal: () =>
      paymentModuleActive
        ? import("~/components/modals/PaymentCancelModal.vue")
        : undefined,
    SelectPlanModal: () =>
      paymentModuleActive
        ? import("~/components/modals/SelectPlanModal.vue")
        : undefined,
  },
})
export default class Showcase extends Vue {
  isFetching = false;

  get paymentModuleActive() {
    return paymentModuleActive;
  }

  get projectId() {
    return this.$route.params.project;
  }

  get isAuth() {
    return this.$store.getters.isAuth as boolean;
  }

  mounted() {
    if (process.client) {
      amplitude.getInstance().logEvent("get_public_project", {
        projectId: this.projectId,
      });
    }
  }

  async fetch() {
    this.isFetching = true;
    if (this.isAuth) {
      await this.$store.dispatch("projects/fetchProjects");
    }
    this.isFetching = false;
  }
}
